import { MouseEvent, useState } from 'react'
import { useStyletron } from 'baseui'
import { StatefulTooltip } from 'baseui/tooltip'
import { useTranslation } from 'react-i18next'

const ClipboardIcon = () => (
  <svg viewBox='0 0 24 24' width={18} height={18} fill='currentColor' aria-hidden='true'>
    <path d='M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z' />
  </svg>
)

const CheckIcon = () => (
  <svg viewBox='0 0 32 32' width={18} height={18} fill='currentColor' aria-hidden='true'>
    <polygon points='14 21.414 9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414' />
  </svg>
)

interface CopyEndEnhancerProps {
  value: string | null | undefined
  stripSpaces?: boolean
}

const CopyEndEnhancer = ({ value, stripSpaces = false }: CopyEndEnhancerProps) => {
  const [, theme] = useStyletron()
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)

  const handleCopy = async (e: MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (!value) return
    const textToCopy = stripSpaces ? value.replace(/\s/g, '') : value
    await navigator.clipboard.writeText(textToCopy)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <StatefulTooltip content={copied ? t('common:copied') : t('common:copy')} returnFocus autoFocus>
      <button
        type='button'
        onClick={handleCopy}
        style={{
          background: 'none',
          border: 'none',
          cursor: value ? 'pointer' : 'default',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: value ? 1 : 0.35,
          color: copied ? 'green' : theme.colors.primaryA,
        }}
      >
        {copied ? <CheckIcon /> : <ClipboardIcon />}
      </button>
    </StatefulTooltip>
  )
}

export default CopyEndEnhancer
